import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CALIDAD_EMBARQUE_TOTAL } from '../../../../config/tables'

export default function CalidadMercaderiaEmbarcadaTotalView () {
  return <MuiTable id={TABLA_CALIDAD_EMBARQUE_TOTAL} />
}
